<div class="workspace-container mobile-build-config">
    <wms-message *ngIf="BuildPreferencesService.showErrorMessage" type="warning" hideclose="true" [scopeDataset]="BuildPreferencesService.message"></wms-message>
    <div class="col-xs-12 build-preference-container full-height">
        <div class="full-height row">
            <div class="build-preference-left-panel col-xs-3">
                <ul class="list-items">
                        <li class="list-item" *ngFor="let item of preferencesSectionObj" (click)="showPreferences($event, item.sectionName)" [ngClass]="{'active': selectedTab === item.sectionName}">
                            <div class="item">
                            <span class="title">{{locale[item.sectionTitle]}}</span>
                            </div>
                        </li>
                </ul>
            </div>
            <div class="scroll-container right-panel col-xs-9">
                <div class="workspace-container-rt">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>